import apiConfig from './api';

const configs = {
  apiConfig,
};

export default configs;
